export default (input: number) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!(window as any).Intl) return input;
    const numberToDecimal = new Intl.NumberFormat('en-US', {
        style: 'decimal'
    });

    return numberToDecimal.format(input);
};
